import { render, staticRenderFns } from "./ChangeCustomFieldName.vue?vue&type=template&id=6df5decc&scoped=true"
import script from "./ChangeCustomFieldName.vue?vue&type=script&lang=js"
export * from "./ChangeCustomFieldName.vue?vue&type=script&lang=js"
import style0 from "./ChangeCustomFieldName.vue?vue&type=style&index=0&id=6df5decc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5decc",
  null
  
)

export default component.exports